<template>
    <div>
        <div class="backs">
            <img class="imgsBack" src="@/assets/mobileStatic/ryback.png" alt="">
            <div class="imgs">
                <div class="imgItem" @click="onShowImg(zs6)">
                    <img class="vertical" :src="zs6" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(jx1)">
                    <img class="horizontal" :src="jx1" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(jx2)">
                    <img class="horizontal" :src="jx2" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(jx3)">
                    <img class="horizontal" src="@/assets/img/classic/ry/jx3.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(jx4)">
                    <img class="horizontal" src="@/assets/img/classic/ry/jx4.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(jx5)">
                    <img class="horizontal" src="@/assets/img/classic/ry/jx5.png" alt="">
                </div>

                <div class="imgItem" @click="onShowImg(zs1)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs1.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(zs2)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs2.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(zs3)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs3.png" alt="">
                </div>

                <div class="imgItem" @click="onShowImg(zs4)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs4.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(zs5)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs5.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(zs7)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs7.png" alt="">
                </div>

                <div class="imgItem" @click="onShowImg(zs8)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs8.png" alt="">
                </div>
                <div class="imgItem" @click="onShowImg(zs9)">
                    <img class="horizontal" src="@/assets/img/classic/ry/zs9.png" alt="">
                </div>
           



            </div>
        </div>
        <div class="showImg" v-show="show">
            <div class="delIcon" @click="show = false">
                <i class="el-icon-circle-close"></i>
            </div>

            <div class="contimg">
                <img :src="showImg" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import jx1 from "@/assets/img/classic/ry/jx1.png"
import jx2 from "@/assets/img/classic/ry/jx2.png"
import jx3 from "@/assets/img/classic/ry/jx3.png"
import jx4 from "@/assets/img/classic/ry/jx4.png"
import jx5 from "@/assets/img/classic/ry/jx5.png"
import zs1 from "@/assets/img/classic/ry/zs1.png"
import zs2 from "@/assets/img/classic/ry/zs2.png"
import zs3 from "@/assets/img/classic/ry/zs3.png"
import zs4 from "@/assets/img/classic/ry/zs4.png"

import zs5 from "@/assets/img/classic/ry/zs5.png"
import zs6 from "@/assets/img/classic/ry/zs6.png"
import zs7 from "@/assets/img/classic/ry/zs7.png"
import zs8 from "@/assets/img/classic/ry/zs8.png"
import zs9 from "@/assets/img/classic/ry/zs9.png"
export default {
    data() {
        return {
            tabIndex: 1,
            show: false,
            showImg: "",
            jx1: jx1,
            jx2: jx2,
            jx3: jx3,
            jx4: jx4,
            jx5: jx5,
            zs1: zs1,
            zs2: zs2,
            zs3: zs3,
            zs4: zs4,
            zs5: zs5,
            zs6: zs6,
            zs7: zs7,
            zs8: zs8,
            zs9: zs9


        }
    },
    methods: {
        onShowImg(url) {
            this.showImg = url;
            this.show = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.showImg {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.8);
    z-index: 99;


    .delIcon {
        position: fixed;
        top: 20px;
        right: 20px;
        z-index: 1000;

        i {
            font-size: 50px;
            color: #fff;
        }
    }

    .contimg {
        display: flex;
        align-items: center;
        width: 100%;
        height: 100vh;

        img {
            width: 100%;
        }
    }
}

.backs {
    .imgsBack {
        width: 100%;
        display: block;
        position: relative;
        z-index: 1;
    }

    .imgs {
        position: absolute;
        width: 100%;
        top: 0;
        z-index: 2;


        .imgItem {
            .horizontal {
                width: 239px;
                height: 169px;
                background-image: url('../../assets/mobileStatic/horizontal.png');
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                overflow: hidden;
            }

            .vertical {
                width: 196px;
                height: 262px;
                background-image: url('../../assets/mobileStatic/vertical.png');
                background-size: 100% 100%;
                padding: 15px;
                box-sizing: border-box;
                overflow: hidden;
            }

            &:nth-child(1) {
                position: absolute;
                top: 193px;
                left: 261px;
            }

            &:nth-child(2) {
                position: absolute;
                top: 603px;
                left: 10px;
            }

            &:nth-child(3) {
                position: absolute;
                top: 603px;
                right: 10px;
            }

            &:nth-child(4) {
                position: absolute;
                top: 809px;
                left: 45px;
            }

            &:nth-child(5) {
                position: absolute;
                top: 524px;
                left: 258px;
            }

            &:nth-child(6) {
                position: absolute;
                top: 809px;
                right: 45px;
            }

            &:nth-child(7) {
                position: absolute;
                top: 1039px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(8) {
                position: absolute;
                top:959px;
                left: 255px;
            }

            &:nth-child(9) {
                position: absolute;
                top: 1039px;
                right: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(10) {
                position: absolute;
                top: 1250px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(11) {
                position: absolute;
                top: 1250px;
                right: 10px;
            }

            &:nth-child(12) {
                position: absolute;
                top: 1400px;
                right: 278px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(13) {
                position: absolute;
                top: 1500px;
                left: 10px;

                img {
                    width: 220px;
                }
            }

            &:nth-child(14) {
                position: absolute;
                top: 1500px;
                right: 10px;

                img {
                    width: 220px;
                }
            }

 
        }

        .boxs {
            background-image: url('../../assets/mobileStatic/ryback1.png');
            background-size: 100% 100%;
            width: 100%;
            height: 292px;
            position: absolute;
            top: 1050px;
            z-index: 3;
            display: flex;
            justify-content: space-between;

            box-sizing: border-box;

            .imgItemRow {
                margin-top: -120px;

                .horizontal {
                    width: 239px;
                    height: 169px;
                    background-image: url('../../assets/mobileStatic/horizontal.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .vertical {
                    width: 196px;
                    height: 262px;
                    background-image: url('../../assets/mobileStatic/vertical.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }
        }

        .boxs1 {
            top: 1390px;
            z-index: 9;

        }

        .boxs2 {
            top: 1650px;
            z-index: 12;

            .imgItemRow {
                margin-top: -120px;

                &:nth-child(2) {
                    margin-top: -220px;
                }
            }
        }

        .boxs3 {
            top: 1500px;
            z-index: 15;


            .imgItemRow {
                margin-top: -120px;
                display: flex;
                justify-content: space-between;
            }
        }

        .one {
            background-image: url('../../assets/mobileStatic/ryback1.png');
            background-size: 100% 100%;
            width: 288px;
            height: 312px;
            position: absolute;
            top: 900px;
            left: 235px;
            z-index: 7;
            display: flex;
            justify-content: center;
            padding: 0 100px;
            box-sizing: border-box;

            .imgItemRow {
                margin-top: -120px;

                .horizontal {
                    width: 239px;
                    height: 169px;
                    background-image: url('../../assets/mobileStatic/horizontal.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                    flex-shrink: 0;
                }

                .vertical {
                    width: 196px;
                    height: 262px;
                    background-image: url('../../assets/mobileStatic/vertical.png');
                    background-size: 100% 100%;
                    padding: 15px;
                    box-sizing: border-box;
                    overflow: hidden;
                }
            }

        }

        .one1 {
            top: 1190px;
            z-index: 11;

            .imgItemRow {
                margin-top: -220px;
            }
        }

    }
}
</style>